import React from "react";

const LABELS = {
  budget: "Budget Fit",
  location: "Location Fit",
  curriculum: "Curriculum Fit",
  interest: "Interest Fit",
  facilities: "Facilities Fit",
  ratio: "Rasio Kelas",
  specialNeeds: "Dukungan Khusus",
};

const barColor = (v) => (v >= 85 ? "#73DCC6" : v >= 65 ? "#FFD966" : "#F58B72");

// Renders a set of labelled progress bars for a match breakdown object.
// `keys` limits/orders which factors are shown.
export default function MatchBreakdown({
  breakdown,
  keys = ["budget", "location", "curriculum", "interest"],
  className = "",
}) {
  return (
    <div className={`space-y-3 ${className}`} data-testid="match-breakdown">
      {keys.map((k) => {
        const v = breakdown[k] ?? 0;
        return (
          <div key={k}>
            <div className="flex items-center justify-between text-sm font-semibold mb-1">
              <span className="text-ink/80">{LABELS[k] || k}</span>
              <span className="text-ink tabular-nums">{v}</span>
            </div>
            <div className="h-2.5 w-full rounded-pill bg-cream-2 overflow-hidden ink-border p-0">
              <div
                className="h-full rounded-pill transition-all duration-500"
                style={{ width: `${v}%`, backgroundColor: barColor(v) }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
